export const CUSTOMER_ONBOARDING_STATUS_REQUEST = "CUSTOMER_ONBOARDING_STATUS_REQUEST";
export const CUSTOMER_ONBOARDING_STATUS_SUCCESS = "CUSTOMER_ONBOARDING_STATUS_SUCCESS";
export const CUSTOMER_ONBOARDING_STATUS_FAILURE = "CUSTOMER_ONBOARDING_STATUS_FAILURE"
export const SAVE_CUSTOMER_ONBOARDING_DETAILS_REQUEST = "SAVE_CUSTOMER_ONBOARDING_DETAILS_REQUEST"
export const SAVE_CUSTOMER_ONBOARDING_DETAILS_FAILURE = "SAVE_CUSTOMER_ONBOARDING_DETAILS_FAILURE"
export const SAVE_CUSTOMER_ONBOARDING_DETAILS_SUCCESS = "SAVE_CUSTOMER_ONBOARDING_DETAILS_SUCCESS"
export const RESET_ONBOARDING_STORE_REQUEST = "RESET_ONBOARDING_STORE_REQUEST";
export const RESET_ONBOARDING_STORE_SUCCESS = "RESET_ONBOARDING_STORE_SUCCESS";
